import UpdateNeeded from './UpdateNeeded'
import PayerType from './PayerType'
import CustomerType from './CustomerType'
export class PayerLinkageInfo {
    RequestID: number;
    CustomerTypeID?: number;
    CustomerType?: CustomerType;
    PayerTypeID?: number;
    PayerType?: PayerType;
    UpdateNeededID?: number;
    UpdateNeeded?: UpdateNeeded;
    ExistingPayerNumber?: string;
    NewPayerNumber?: string;
    //CustomerNumbers?: string;
}

export default PayerLinkageInfo;